const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrasadNavMob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.646,
    height: 32.896,
    viewBox: "0 0 45.646 32.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 28163"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 28162"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 28161"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66764",
    d: "M43.423 94.743h-3.13a5.308 5.308 0 0 0 1.52-2.312.669.669 0 1 0-1.27-.419 3.979 3.979 0 1 1-.062-2.671.669.669 0 1 0 1.249-.479 5.353 5.353 0 0 0-4.33-3.376 5.325 5.325 0 0 0-4.648-4.647 5.325 5.325 0 0 0-4.652-4.648 5.315 5.315 0 0 0-10.555 0 5.325 5.325 0 0 0-4.645 4.648 5.325 5.325 0 0 0-4.65 4.647 5.318 5.318 0 0 0-2.89 9.256H2.223A2.226 2.226 0 0 0 0 96.966v.857a2.226 2.226 0 0 0 2.223 2.223h4.611a10.429 10.429 0 0 1 3.326 3.47 1.826 1.826 0 0 0 1.563.886h9.54a.669.669 0 0 0 0-1.337h-9.54a.482.482 0 0 1-.414-.232 12.415 12.415 0 0 0-2.266-2.786H36.6a12.431 12.431 0 0 0-2.245 2.749.559.559 0 0 1-.477.269h-9.5a.669.669 0 1 0 0 1.337h9.5a1.9 1.9 0 0 0 1.624-.918 10.436 10.436 0 0 1 3.306-3.437h4.611a2.226 2.226 0 0 0 2.223-2.223v-.857a2.226 2.226 0 0 0-2.219-2.224zm-10.177 0h-2.255a5.349 5.349 0 0 0 1.127-1.4 5.349 5.349 0 0 0 1.127 1.4zM14.2 90.764a3.978 3.978 0 1 1 3.979 3.979 3.983 3.983 0 0 1-3.979-3.979zm.459 3.979H12.4a5.351 5.351 0 0 0 1.127-1.4 5.349 5.349 0 0 0 1.128 1.4zm4.234-9.243a3.979 3.979 0 0 1 7.86 0 5.335 5.335 0 0 0-3.93 2.689 5.342 5.342 0 0 0-3.93-2.689zm3.93 7.845a5.351 5.351 0 0 0 1.127 1.4H21.7a5.351 5.351 0 0 0 1.123-1.404zm.669-2.577a3.979 3.979 0 1 1 3.979 3.979 3.983 3.983 0 0 1-3.98-3.983zM36.048 85.5a5.341 5.341 0 0 0-3.931 2.689 5.341 5.341 0 0 0-3.93-2.689 3.979 3.979 0 0 1 7.861 0zM31.4 80.848a5.341 5.341 0 0 0-3.931 2.689 5.341 5.341 0 0 0-3.93-2.689 3.979 3.979 0 0 1 7.861 0zm-8.578-8.006a3.985 3.985 0 0 1 3.931 3.358 5.339 5.339 0 0 0-3.931 2.689 5.341 5.341 0 0 0-3.93-2.689 3.985 3.985 0 0 1 3.931-3.358zm-4.647 4.648a3.987 3.987 0 0 1 3.93 3.358 5.339 5.339 0 0 0-3.93 2.689 5.343 5.343 0 0 0-3.931-2.689 3.985 3.985 0 0 1 3.931-3.358zm-4.184 4.675a3.986 3.986 0 0 1 3.467 3.335 5.344 5.344 0 0 0-3.93 2.689A5.338 5.338 0 0 0 9.6 85.5a3.983 3.983 0 0 1 4.391-3.335zM4.9 90.764a3.978 3.978 0 1 1 3.98 3.979 3.983 3.983 0 0 1-3.98-3.979zm39.407 7.059a.887.887 0 0 1-.886.886H2.223a.887.887 0 0 1-.886-.886v-.857a.887.887 0 0 1 .886-.886h41.2a.887.887 0 0 1 .886.886z",
    transform: "translate(0 -71.505)",
    style: {
      fill: "#767676"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66765",
    d: "M79.216 268.344c.4 0 .518-.245 1-.865a.669.669 0 0 0-1.054-.823l-.474.607a.669.669 0 0 0 .528 1.081z",
    transform: "translate(-71.544 -249.023)",
    style: {
      fill: "#767676"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66766",
    d: "M181.735 268.2a.669.669 0 0 0 .939-.115l.474-.607a.669.669 0 1 0-1.054-.823l-.474.607a.669.669 0 0 0 .115.938z",
    transform: "translate(-165.299 -249.025)",
    style: {
      fill: "#767676"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66767",
    d: "M284.166 268.2a.669.669 0 0 0 .939-.115l.474-.607a.669.669 0 1 0-1.054-.823l-.474.607a.669.669 0 0 0 .115.938z",
    transform: "translate(-258.598 -249.025)",
    style: {
      fill: "#767676"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66768",
    d: "m387.437 266.657-.475.607a.669.669 0 0 0 .526 1.08c.4 0 .518-.245 1-.865a.669.669 0 1 0-1.054-.823z",
    transform: "translate(-352.334 -249.025)",
    style: {
      fill: "#767676"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrasadNavMob);
export default __webpack_public_path__ + "static/media/prasad-nav-mob.5e1488efca42ca200a1663c8b0dd7e3f.svg";
export { ForwardRef as ReactComponent };